'use strict';

import angular from 'angular';
import routes from './admin.routes';
import AdminController from './admin.controller';
const uiRouter = require('angular-ui-router');

export default angular.module('conduu.userList', [uiRouter])
  .config(routes)
  .controller('AdminController', AdminController)
  .name;



// WEBPACK FOOTER //
// ./client/app/admin/user-list/index.js